import Vue from 'vue'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

Vue.component('Splitpanes', Splitpanes);
Vue.component('Pane', Pane);
